import React, { useState } from "react";
import MatterOverviewSidebar from "./components/MatterOverviewSidebar";
import MatterOverview from "./components/MatterOverview";
import { matterOverviewSections, MatterOverviewSection } from "./types";
import MatterParties from "./components/MatterParties";
import CourtDetailsSection from "./components/CourtDetailsSection";
import RelationshipDetailsSection from "./components/RelationshipDetailsSection";
import { Heading } from "../../design/heading";

const MatterOverviewPage: React.FC = () => {
  const [activeSection, setActiveSection] =
    useState<MatterOverviewSection>("Basic Information");

  const renderSection = () => {
    switch (activeSection) {
      case "Basic Information":
        return <MatterOverview />;
      case "Parties":
        return <MatterParties />;
      case "Relationship Details":
        return <RelationshipDetailsSection />;
      case "Court Details":
        return <CourtDetailsSection />;
      // case "Deadlines & Key Dates":
      //   return <DeadlinesSection />;
      // case "Issues & Questions":
      //   return <IssuesQuestionsSection />;
      // case "Financials":
      //   return <FinancialsSection />;
      // case "Evidence & Documents":
      //   return <EvidenceDocumentsSection />;
      // case "Orders & Filings":
      //   return <OrdersFilingsSection />;
      // case "Communication & Notes":
      //   return <CommunicationNotesSection />;
      default:
        return <MatterOverview />;
    }
  };

  return (
    <div>
      <Heading>Matter Overview</Heading>
      <div className="flex h-full">
        <MatterOverviewSidebar
          sections={matterOverviewSections}
          activeSection={activeSection}
          onSectionChange={setActiveSection}
        />
        <main className="flex-grow h-full p-4 border rounded-md bg-gray-50">
          {renderSection()}
        </main>
      </div>
    </div>
  );
};

export default MatterOverviewPage;
